import Navbar from "../components/navbar";
import Footer from "./homepage/component/footer";
import Carousel from "./homepage/component/carousel";
import Vant_Team from "../assets/webp/VANT Team.webp";
import DotCircle from "../assets/icons/circle-dot.svg";
import FolderIcon from "../assets/icons/FolderPlus-logo-overlay.svg";
import ShareIcon from "../assets/icons/Share-logo-overlay.svg";
import HandArrowDown from "../assets/icons/HandArrowDown-logo-overlay.svg";
import AboutTeamImage from "../assets/images/Vant about picture.png";
import LineDrawn from "../assets/icons/line-vector.svg";
import LagosInnovates from "../assets/icons/lagos-innovates.svg";
import WemaBank from "../assets/icons/wema-bank-logo.svg";
import ProvidusBank from "../assets/icons/providus-bank.svg";
import VFDBank from "../assets/icons/vfd-bank.svg";
import OrangeCorners from "../assets/icons/orange-bank.svg";
import NGR from "../assets/icons/NGR.svg";
import AWS from "../assets/icons/aws-logo.svg";
import ImpactHub from "../assets/icons/impact-hub.svg";
import SafeHaven from "../assets/icons/safe-haven.svg";
import WIPO from "../assets/icons/wipo-logo.svg";
import Paystack from "../assets/icons/Paystack.svg";
import OpenAI from "../assets/icons/openai.svg";
import NitdaNDPR from "../assets/icons/nitda-NPDR-logo.svg";
import LSETF from "../assets/icons/lsetf-logo.svg";
import MicrosoftAzure from "../assets/icons/microsoft-azure.svg";
import MissionBgImage from "../assets/webp/mission_bg-image.webp";
import EmpowerIcon from "../assets/icons/empower-individuals.svg";
import InnovateIcon from "../assets/icons/innovate-continously.svg";
import TrustSecurity from "../assets/icons/trust-security.svg";
import IntegrityImage from "../assets/icons/integrity-image.svg";
import TransparencyIcon from "../assets/icons/transparency.svg";
import InnovatingContinous from "../assets/icons/innovate-continously.svg";
import AccountabilityIcon from "../assets/icons/accountability.svg";
import ChartIcon from "../assets/icons/chart-icon.svg";
import CustomCentricity from "../assets/icons/customer-centric.svg";
import ContinousInnovation from "../assets/icons/continous_innovation.svg";
import Avatar1 from "../assets/images/avatar1.png";
import Avatar2 from "../assets/images/avatar2.png";
import Avatar3 from "../assets/images/avatar3.png";
import Avatar4 from "../assets/images/avatar4.png";
import Avatar5 from "../assets/images/avatar5.png";
import Pointer from "../assets/icons/pointer-finance.svg";
import PaulAkolade from "../assets/images/paul-akolade.png";
import FintechPicture from "../assets/images/fintech-blog.png";
import BlogThird from "../assets/images/blog-news-third.png";
import { Calendar, Clock, ArrowCircleRight2 } from "iconsax-react";
import VantAppPreview from "../assets/webp/vant-mobile-preview.webp";
import GooglePlayDownload from "../assets/icons/google-play.svg";
import AppStoreDownload from "../assets/icons/app-store.svg";
import "../animate.css";
import { Link } from "react-router-dom";
import Partners from "../components/Partners";
import PointText from "../components/PointText";
import BlogComp from "./homepage/component/blogcomp";

const newsData = [
  {
    img: PaulAkolade,
    date: "July 20, 2024",
    readTime: "3 Min. Read",
    title:
      "Vant Founder, Akolade Unveils Vision To Revolutionize Personal Finance In Nigeria",
    link: "#",
  },
  {
    img: FintechPicture,
    date: "July 28, 2024",
    readTime: "4 Min. Read",
    title:
      "Vant Founder, Akolade Unveils Vision To Revolutionize Personal Finance In Nigeria",
    link: "#",
  },
  {
    img: BlogThird,
    date: "July 29, 2024",
    readTime: "3 Min. Read",
    title:
      "Vant Founder, Akolade Unveils Vision To Revolutionize Personal Finance In Nigeria",
    link: "#",
  },
];

const NewCompany = () => {
  return (
    <div>
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="flex flex-col px-4 py-10 md:p-16 gap-10 md:gap-16 bg-[url('./assets/images/dots.png')]">
          <div className="flex flex-col md:flex-row justify-between">
        <h1 className="text-4xl md:text-5xl font-bold leading-tight">
              Innovating finance for the{" "}
              <span className="text-[#32AE4C]">future</span>
            </h1>

        <p className="mt-6 text-lg text-gray-600 max-w-lg">
              Secured and inclusive solutions designed to power businesses and
              Individuals
            </p>
          </div>

          <div className=" ">
            <img src={Vant_Team} className="w-full" alt="Vant Team" />
          </div>
        </section>

        {/* About Section */}
        <section className="flex flex-col md:flex-row justify-between px-4 py-10  gap-[2rem] md:p-24 items-center">
          <div className="flex flex-col gap-4">
            <h3 className="flex gap-[10px] m-0 border border-[#32AE4C] text-[#32AE4C] rounded-[15px] w-fit items-center justify-center py-[0.1rem] pr-[0.9rem] pl-[0.4rem] font-medium">
              <img src={DotCircle} alt="" />
              <span>About Us</span>
            </h3>
            <h4 className="m-0 font-bold text-[1.5rem] md:text-[1.9rem] w-[100%] md:w-1/2 leading-[normal]">
              Vant is revolutionizing business banking
            </h4>

            <p className="m-0 font-normal w-[100%] md:w-[56%]">
              Providing seamless financial solutions for SMEs and entrepreneurs.
              Our mission is to simplify business transactions and enhance
              financial growth with innovative digital banking tools.
            </p>
          </div>

          <div className="relative rounded-[12px]">
            <img
              src={AboutTeamImage}
              alt="Vant_About_Team"
              className="w-[90%]"
            />

            <div className="absolute flex gap-2 font-normal bg-white py-2 px-3 rounded-lg text-[14px] shadow-md top-3/5 -left-1/6 pr-[2rem] top-[40%] left-[-1%] md:top-[60%] md:left-[-15%]">
              <img src={FolderIcon} alt="" />
              <span>Transparency</span>
            </div>

            <div className="absolute flex gap-2 font-normal bg-white py-2 px-3 rounded-lg text-[14px] shadow-md top-3/5 -left-1/6 pr-[2rem] top-[55%] left-[20%] md:top-[80%] md:left-[10%] transform -translate-y-[-50%]">
              <img src={ShareIcon} alt="" />
              <span>Innovation</span>
            </div>

            <div className="absolute flex gap-2 font-normal bg-white py-2 px-3 rounded-lg text-[14px] shadow-md top-3/5 -left-1/6 pr-[2rem] bottom-[5%] right-[6%] md:bottom-[10px] md:right-[-6%]">
              <img src={HandArrowDown} alt="" />
              <span>Custom-centric solutions</span>
            </div>
          </div>
        </section>

        {/* Partners Section */}
        <section className="text-center  md:my-12 px-4 py-10 md:p-16 flex flex-col gap-8">
       
            <Partners />
       
       
          {/* <h4 className="m-0 font-bold md:text-[1.9rem] leading-[normal]">
            Our Recent Clients &amp; Partners
          </h4>

          <div className="overflow-hidden whitespace-nowrap">
            <div
              className="animate__animated animate__infinite inline-flex gap-8"
              style={{
                animation: "slidePartner 10s linear infinite",
                willChange: "transform",
              }}
            >
              <img
                src={LagosInnovates}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={WemaBank}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={ProvidusBank}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={VFDBank}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={OrangeCorners}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={NGR}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={AWS}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={SafeHaven}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={ImpactHub}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={WIPO}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={Paystack}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={OpenAI}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={NitdaNDPR}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={LSETF}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
              <img
                src={MicrosoftAzure}
                alt=""
                className="h-12 object-contain hover:grayscale cursor-pointer"
              />
            </div>
          </div>

          <div>
            <p>Join 4000+ companies already growing</p>
          </div> */}
        </section>

        {/* Mission Vision Section */}
        <section className="md:max-w-6xl my-0 mx-auto px-4 py-10 md:p-16 relative">
          <div>
            <img
              src={MissionBgImage}
              alt="Team working in office"
              className="w-full rounded-[30px]"
            />
          </div>

          <div className="flex gap-2 md:gap-8 -mt-20 relative z-10 justify-center px-0 md:px-12 py-0">
            <div className="my-4 mx-0 flex-grow flex-shrink basis-[360px]  md:basis-[350px] p-2 md:p-8 rounded-[15px] shadow-lg bg-[#061b3c] text-white">
              <h3 className="text-[1rem] md:text-2xl  mb-2 m-0 text-center md:mb-4 font-semibold">
                OUR MISSION
              </h3>
              <p className="md:leading-relaxed text-[0.65rem] text-center md:text-[1rem]">
                "At Vant, we are committed to revolutionize how African SMBs
                manage finances by providing intuitive, AI-driven tools that
                simplify operations, enhance cash flow and unlock opportunities
                for scalability and success"
              </p>
            </div>

            <div className="flex-grow flex-shrink basis-[290px] md:basis-[350px] p-2 md:p-8 rounded-[15px] shadow-lg bg-[#fff] text-[#333] my-4 mx-0">
              <h3 className="text-[1rem] md:text-2xl m-0 mb-2 text-center md:mb-4 font-semibold">
                OUR VISION
              </h3>
              <p className="md:leading-relaxed text-[0.65rem] text-center md:text-[1rem]">
                "To empower African Businesses with seamless financial
                management tools that drive growth, innovation and economic
                transformation."
              </p>
            </div>
          </div>
        </section>

        {/* Area of Focus Section */}
        <section className="bg-[url('./assets/icons/area-focus-bg.svg')] p-4 md:p-16 bg-[#0a1f30] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-center">
          <div className="rounded-[10px] md:flex-grow md:flex-shrink md:basis-[30%] p-3 md:p-5 shadow-sm md:flex flex-col md:m-[15px] md:gap-[1rem]">
            <h2 className="text-[1.4rem] md:text-5xl mb-[10px] text-white font-medium">
              Area of Focus
            </h2>
            <p className="text-[1rem] md:text-[1.4rem] text-[#cbd5e1]">
              At Vant, we are committed to revolutionizing how African SMBs
              manage finances through the following principles:
            </p>
          </div>

          <div className="rounded-[10px] flex-grow flex-shrink basis-[30%] p-2 md:p-5 shadow-sm flex flex-col m-[15px] gap-[1rem] flex-1 mx-4 my-4 bg-white text-[#282828]">
            <div>
              <img src={EmpowerIcon} alt="" />
            </div>
            <h3 className="text-[1.1rem] md:text-2xl font-semibold leading-8 m-0">
              Empowering Individuals
            </h3>
            <p className="text-sm leading-normal m-0">
              We build tools that help everyday people take control of their
              money—save, invest, and thrive financially.
            </p>
          </div>

          <div className="rounded-[10px] flex-grow flex-shrink basis-[30%] p-2 md:p-5 shadow-sm flex flex-col m-[15px] gap-[1rem] flex-1 mx-4 my-4 bg-[#32AE4C] text-white ">
            <div>
              <img src={EmpowerIcon} alt="" />
            </div>
            <h3 className="text-[1.1rem] md:text-2xl font-semibold leading-8 m-0">
              Cultivating Financial Education
            </h3>
            <p className="text-sm leading-normal m-0">
              We simplify finance for everyone, offering education that helps
              users make smarter, confident money decisions.
            </p>
          </div>

          <div className="rounded-[10px] flex-grow flex-shrink basis-[30%] p-2 md:p-5 shadow-sm flex flex-col m-[15px] gap-[1rem] flex-1 mx-4 my-4 bg-[#32AE4C] text-white">
            <div>
              <img src={InnovateIcon} alt="" />
            </div>
            <h3 className="text-[1.1rem] md:text-2xl font-semibold leading-8 m-0">
              Innovating Continuously
            </h3>
            <p className="text-sm leading-normal m-0">
              We listen, learn, and ship quickly—building modern financial tools
              that solve real African business and personal needs.
            </p>
          </div>

          <div className="rounded-[10px] flex-grow flex-shrink basis-[30%] p-2 md:p-5 shadow-sm flex flex-col m-[15px] gap-[1rem] flex-1 mx-4 my-4 bg-white text-[#282828]">
            <div>
              <img src={ChartIcon} alt="" />
            </div>
            <h3 className="text-[1.1rem] md:text-2xl font-semibold leading-8 m-0">
              Supporting Business Growth
            </h3>
            <p className="text-sm leading-normal m-0">
              From solo entrepreneurs to large enterprises, we create scalable
              tools that streamline operations and accelerate growth.
            </p>
          </div>

          <div className="rounded-[10px] flex-grow flex-shrink basis-[30%] p-2 md:p-5 shadow-sm flex flex-col m-[15px] gap-[1rem] flex-1 mx-4 my-4 bg-[#32AE4C] text-white">
            <div>
              <img src={TrustSecurity} alt="" />
            </div>
            <h3 className="text-[1.1rem] md:text-2xl font-semibold leading-8 m-0">
              Upholding Trust and Security
            </h3>
            <p className="text-sm leading-normal m-0">
              We prioritize data privacy, compliance, and bank-grade security to
              protect every transaction and user detail.
            </p>
          </div>
        </section>

        {/* Values Section */}
        <section className="flex flex-col px-4 py-10 md:p-16 text-center justify-center gap-6">
          <h2 className="flex gap-[10px] border border-[#32AE4C] text-[#32AE4C] rounded-[15px] w-fit pt-[0.1rem] pb-[0.1rem] pr-[0.9rem] pl-[0.4rem] font-medium my-[0] mx-auto">
            <img src={DotCircle} alt="" />
            <span>Our Values</span>
          </h2>

          {/* <PointText text={"Our Values"}/> */}

          <h3 className="m-0 font-bold text-center text-[1.5rem] md:text-[1.9rem] leading-[normal]">
            Our Core Values
          </h3>

          <p className=" w-[90%] text-gray-400 text-[0.9rem] md:text-[1rem] text-center md:w-2/5 mx-auto my-0">
            At Vant, we are committed to revolutionize how African SMBs manage
            finances by providing intuitive.
          </p>

          <div className="flex flex-col p-0 w-[100%]  md:grid md:grid-cols-3 md:gap-5 md:p-5 items-center">
            <div className="p-5 rounded-[10px] text-left flex flex-col gap-4 bg-[#131313] my-[1rem] mx-0 text-white w-[100%]">
              <div>
                <img src={TrustSecurity} alt="" />
              </div>

              <h3 className="font-medium text-[1.4rem] m-0">Integrity</h3>
              <p className="m-0 text-base">
                Vant is committed to continuously exploring new ways to improve
                its offerings and meet the evolving needs of their customers.
              </p>

              <div>
                <img src={IntegrityImage} alt="" />
              </div>
            </div>

            <div className="flex flex-col gap-5 w-[100%]">
              <div className="p-5 rounded-[10px] text-left flex flex-col gap-4 bg-[#32AE4C] text-white my-[1rem] mx-0">
                <div>
                  <img src={TransparencyIcon} alt="" />
                </div>

                <h3 className="font-medium text-[1.4rem] m-0">Transparency</h3>
                <p className="m-0 text-base ">
                  The brand aims to make its services accessible to everyone,
                  regardless of their location or income level.
                </p>
              </div>

              <div className="p-5 rounded-[10px] text-left flex flex-col gap-4 bg-[#131313] text-white my-[1rem] mx-0">
                <div>
                  <img src={ContinousInnovation} alt="" />
                </div>

                <h3 className="font-medium text-[1.4rem] m-0">
                  Continous Innovation
                </h3>
                <p className="m-0 text-base">
                  Create solutions that are inclusive and accessible to
                  everyone, regardless of their background or previous
                  experiences.
                </p>
              </div>

              <div className="p-5 rounded-[10px] text-left flex flex-col gap-4 bg-[#32AE4C] text-white my-[1rem] mx-0">
                <div>
                  <img src={AccountabilityIcon} alt="" />
                </div>

                <h3 className="font-medium text-2xl m-0">Accountability</h3>
                <p className="m-0 text-base">
                  We take ownership of our actions and responsibilities,
                  ensuring that our commitments are met with dedication.
                </p>
              </div>
            </div>

            <div className="p-5 rounded-[10px] text-left flex flex-col gap-4 bg-[#32AE4C] text-white w-full my-[1rem] mx-0">
              <div>
                <img src={ChartIcon} alt="" />
              </div>

              <h3 className="font-medium text-[1.4rem] m-0">
                Customer Centricity
              </h3>
              <p className="m-0 text-base">
                Vant prioritizes sustainability in all aspects of business, from
                its operations to the impact of their services on the
                environment.
              </p>

              <div>
                <img src={CustomCentricity} alt="" />
              </div>
            </div>
          </div>
        </section>

        {/* Finance Part Section */}
        <section className="m-0 relative flex items-center justify-center text-center bg-[url('./assets/icons/finance-part-bg.svg')] mx-8 md:mx-16 rounded-[15px] p-8 md:pt-[5rem] md:pr-[6rem] md:pb-[10rem] md:pl-[10rem]">
          <div>
            <h2 className="text-[1.4rem] md:text-[2rem] mb-4 text-white font-semibold">
              Be part of the future of{" "}
              <span className="text-[#32AE4C]">finance!</span>
            </h2>
            <p className="text-[0.7rem] md:text-[1.2rem] mb-6 text-white">
              Join team of innovators, problem solvers and changemakers
              committed to
              <br />
              reshaping financial experience across Africa
            </p>
            <button className="py-[0.4rem] md:py-[0.8rem] px-4 md:px-8 text-base border-none rounded-[30px] bg-[#32AE4C] text-white cursor-pointer hover:bg-[#22a635]">
              <Link to="https://business.vant.ng/signup">Join Now</Link>
            </button>
          </div>

          <img
            src={Avatar1}
            className="absolute w-[30px] h-[30px] md:w-16 md:h-16 rounded-[50%] border-2 border-white object-cover md:top-[15%] md:left-[10%] top-[4%] left-[1%] "
            alt="Avatar 1"
          />
          <img
            src={Avatar2}
            className="absolute w-[30px] h-[30px] md:w-16 md:h-16 rounded-[50%] border-2 border-white object-cover md:bottom-[20%] md:left-[15%] bottom-[20%] left-[15%]"
            alt="Avatar 2"
          />
          <img
            src={Avatar3}
            className="hidden md:block absolute w-16 h-16 rounded-[50%] border-2 border-white object-cover bottom-[10%] left-[50%] transform -translate-x-[50%]"
            alt="Avatar 3"
          />
          <img
            src={Avatar4}
            className="absolute w-[40px] h-[40px] md:w-16 md:h-16 rounded-[50%] border-2 border-white object-cover md:top-[20%] md:right-[10%] top-[20%] right-[1%]"
            alt="Avatar 4"
          />
          <img
            src={Avatar5}
            className="absolute w-[30px] h-[30px] md:w-16 md:h-16 rounded-[50%] border-2 border-white object-cover md:bottom-[20%] md:right-[15%] bottom-[10%] right-[5%]"
            alt="Avatar 5"
          />

          <img
            src={Pointer}
            className="absolute w-[30px] md:w-[50px] bottom-[3%] md:bottom-[23%] left-[58%] transform -rotate-[5deg] z-[3]"
            alt="Pointer"
          />
        </section>

        {/* News Update Section */}
        {/* <section className="py-[24px] px-4 md:py-12 md:px-6 bg-white text-center">
          <div className="mb-8">
            <span className="inline-block text-[#16c784] border border-[#16c784] rounded-3xl py-1 px-[18px] font-medium text-base">
              ● News Update
            </span>
            <h2 className="text-[1.4rem] md:text-3xl font-bold my-4 text-[#222]">
              Explore news from Vant Africa
            </h2>
            <p className="text-[0.9rem] md:text-[1.1rem] max-w-3xl mx-auto mb-20">
              Vant Africa has been featured in several notable publications and
              initiatives, highlighting its impact and contributions across
              various sectors.
            </p>
          </div>
          <div className="flex flex-wrap gap-6 justify-center my-8">
            {newsData.map((news, index) => (
              <div
                key={index}
                className="rounded-2xl overflow-hidden px-4 md:px-0 w-80 flex flex-col items-start transition-transform hover:translate-y-[-6px] hover:scale-[1.03] gap-[10px]"
              >
                <img
                  src={news.img}
                  alt="News"
                  className="w-[100%] object-cover"
                />
                <div className="text-[#2E47E3] bg-[#2E47E333] p-[0.3rem] rounded-md font-medium">
                  Innovation
                </div>
                <div className="flex items-center gap-2 text-[15px] text-[#3F3F3F]">
                  <span>
                    <Calendar size="16" color="#DFDFDF" variant="Bold" />
                  </span>
                  <span>{news.date}</span>
                  <span>
                    <Clock size="16" color="#DFDFDF" variant="Bold" />
                  </span>
                  <span>{news.readTime}</span>
                </div>
                <h3 className="text-[0.9rem] md:text-[1.1rem] font-semibold text-black text-left m-0">
                  {news.title}
                </h3>
                <a
                  href={news.link}
                  className="text-[#32AE4C] font-medium no-underline flex items-center gap-1 hover:underline m-[0]"
                >
                  Read more{" "}
                  <span>
                    <ArrowCircleRight2 />
                  </span>
                </a>
              </div>
            ))}
          </div>
          <div>
            <button className="bg-[#32AE4C] text-white border-none rounded-3xl py-2 md:py-[14px] px-4 md:px-10 text-[0.9rem] md:text-[1.1rem] font-semibold cursor-pointer hover:bg-[#13a06d]">
              View All Blog
            </button>
          </div>
        </section> */}
      <BlogComp />

        <div className="px-4 md:px-16">
          <Carousel />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NewCompany;
